module.exports = __webpack_public_path__ + "static/app-store-badge-94f05473f2d4d892faafacc9feb03ea2.svg";